import { render, staticRenderFns } from "./RelatorioDeApuracaoDeFalta.vue?vue&type=template&id=40249d80"
import script from "./RelatorioDeApuracaoDeFalta.vue?vue&type=script&lang=js"
export * from "./RelatorioDeApuracaoDeFalta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports